import isFunction from 'lodash-es/isFunction'
import isUndefined from 'lodash-es/isUndefined'

import { EMPTY_OBJECT } from '../../../constants/common'

export class ControlsStore {
  controls = null

  constructor(controls) {
    this.controls = controls ?? EMPTY_OBJECT
  }

  add(control, omitted = false) {
    return control
      ? new ControlsStore({
          ...this.controls,
          [control.name]: { ...control, omitted },
        })
      : this
  }

  get(name) {
    return this.controls[name]
  }

  getControls() {
    return { ...this.controls }
  }

  getValues() {
    const { controls } = this

    return Object.keys(controls).reduce((props, key) => {
      const config = controls[key]
      const omitted = config?.omitted
      const value = config?.value

      return omitted || isUndefined(value)
        ? props
        : { ...props, [key]: isFunction(value) ? value(props) : value }
    }, {})
  }

  merge(controls) {
    return new ControlsStore({
      ...this.controls,
      ...controls.controls,
    })
  }

  remove(name) {
    const { [name]: control, ...rest } = this.controls

    return control ? new ControlsStore({ ...rest }) : this
  }

  setOmitted(name, omitted) {
    return this.update(name, { omitted })
  }

  setValue(name, value) {
    return this.update(name, { value })
  }

  update(name, props) {
    const { [name]: control } = this.controls

    return control
      ? new ControlsStore({
          ...this.controls,
          [name]: { ...control, ...props },
        })
      : this
  }
}
